import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Linkedin, Instagram } from 'lucide-react';
import { useState } from 'react';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleNewsletterSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;

    setLoading(true);
    try {
      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          access_key: 'YOUR_WEB3FORMS_ACCESS_KEY', // Replace with your Web3Forms key
          email: email,
          subject: 'New Newsletter Subscription - LMR IMPEX',
          from_name: 'LMR IMPEX Website',
          to_email: 'admin@lmrimpex.com'
        })
      });

      const data = await response.json();
      
      if (data.success) {
        alert('Thank you for subscribing to our newsletter!');
        setEmail('');
      } else {
        alert('Failed to subscribe. Please try again.');
      }
    } catch (error) {
      alert('Failed to subscribe. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer className="bg-slate-900 text-white" data-testid="footer">
      <div className="max-w-screen-2xl mx-auto px-6 md:px-12 lg:px-24 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <h3 className="text-2xl font-bold mb-4">LMR IMPEX</h3>
            <p className="text-slate-400 text-sm leading-relaxed mb-4">
              Engineering Precision. Global Reach. Curated Luxury.
            </p>
            <p className="text-slate-400 text-sm leading-relaxed">
              From automated furniture manufacturing to international exports and turnkey interiors.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-bold uppercase tracking-widest mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-slate-400 hover:text-bronze-500 transition-colors text-sm">About Us</Link></li>
              <li><Link to="/furniture" className="text-slate-400 hover:text-bronze-500 transition-colors text-sm">Furniture & Interiors</Link></li>
              <li><Link to="/export" className="text-slate-400 hover:text-bronze-500 transition-colors text-sm">Export Division</Link></li>
              <li><Link to="/manufacturing" className="text-slate-400 hover:text-bronze-500 transition-colors text-sm">Manufacturing</Link></li>
              <li><Link to="/projects" className="text-slate-400 hover:text-bronze-500 transition-colors text-sm">Projects</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-sm font-bold uppercase tracking-widest mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-bronze-500 mt-1 flex-shrink-0" />
                <span className="text-slate-400 text-sm">LMR IMPEX<br/>Visakhapatnam, Andhra Pradesh, India</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-4 h-4 text-bronze-500 flex-shrink-0" />
                <a href="tel:+919866019988" className="text-slate-400 text-sm hover:text-bronze-500 transition-colors">+91-9866019988</a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-4 h-4 text-bronze-500 flex-shrink-0" />
                <a href="mailto:admin@lmrimpex.com" className="text-slate-400 text-sm hover:text-bronze-500 transition-colors">admin@lmrimpex.com</a>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h4 className="text-sm font-bold uppercase tracking-widest mb-4">Newsletter</h4>
            <p className="text-slate-400 text-sm mb-4">Stay updated with our latest products and projects.</p>
            <form onSubmit={handleNewsletterSubmit} className="flex gap-2" data-testid="newsletter-form">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Your email"
                data-testid="newsletter-email-input"
                className="flex-1 px-4 py-2 bg-slate-800 border border-slate-700 text-white text-sm focus:outline-none focus:border-bronze-500 transition-colors"
                required
              />
              <button
                type="submit"
                disabled={loading}
                data-testid="newsletter-submit-button"
                className="px-6 py-2 bg-bronze-500 text-white text-xs font-bold uppercase tracking-widest hover:bg-bronze-600 transition-colors disabled:opacity-50"
              >
                {loading ? 'Subscribing...' : 'Subscribe'}
              </button>
            </form>
          </div>
        </div>

        {/* Social Links */}
        <div className="flex items-center justify-between pt-8 border-t border-slate-800">
          <p className="text-slate-400 text-sm">
            © {new Date().getFullYear()} LMR IMPEX. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-slate-400 hover:text-bronze-500 transition-colors" aria-label="Facebook">
              <Facebook className="w-5 h-5" />
            </a>
            <a href="#" className="text-slate-400 hover:text-bronze-500 transition-colors" aria-label="LinkedIn">
              <Linkedin className="w-5 h-5" />
            </a>
            <a href="#" className="text-slate-400 hover:text-bronze-500 transition-colors" aria-label="Instagram">
              <Instagram className="w-5 h-5" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
